/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductExportImportDto } from '../models/pom-product-export-import-dto';


/**
 * the Product export API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductExportService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation exportProductByInternalId
   */
  static readonly ExportProductByInternalIdPath = '/product/{internalId}/export';

  /**
   * Get product with its relative components by internal id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportProductByInternalId()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportProductByInternalId$Response(params: {
    internalId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductExportImportDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductExportService.ExportProductByInternalIdPath, 'get');
    if (params) {
      rb.path('internalId', params.internalId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductExportImportDto>;
      })
    );
  }

  /**
   * Get product with its relative components by internal id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportProductByInternalId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportProductByInternalId(params: {
    internalId: string;
  },
  context?: HttpContext

): Observable<PomProductExportImportDto> {

    return this.exportProductByInternalId$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductExportImportDto>) => r.body as PomProductExportImportDto)
    );
  }

}
